class MobileMenu {
  constructor() {
    this.btn = document.getElementById('menu-btn');
    this.menu = document.getElementById('menu');
    this.menuItems = menu?.querySelectorAll('.menu-item');
    this.events();
  }

  events() {
    this.btn.addEventListener('click', this.navToggle.bind(this));
    this.menuItems.forEach(item =>
        item.addEventListener('click', this.navToggle.bind(this))
    );
  }

  navToggle() {
    this.btn.classList.toggle('open');
    this.menu.classList.toggle('block');
    this.menu.classList.toggle('hidden');
  }
}
export default MobileMenu;
